export default {"src":"/_next/static/media/video.9d680ac6.svg","height":26,"width":27};